/** Logo colour tokens — keep `public/logo-*.svg` and `TechnoConixLogo` in sync */

export type LogoThemePalette = {
  ink: string;
  markGradient: { from: string; to: string };
  wordGradient: { from: string; to: string };
  tileFill: string;
  tileSoft?: { from: string; fromOpacity: number; to: string; toOpacity: number };
  nodes: { top: string; br: string; bl: string };
  frameOpacity: number;
  linkOpacity: number;
  meshOpacity: number;
  hubRingOpacity: number;
};

export const LOGO_PALETTE = {
  light: {
    ink: '#1F1F1F',
    markGradient: { from: '#1C39F5', to: '#0E8FBF' },
    wordGradient: { from: '#132CB5', to: '#1C39F5' },
    tileFill: '#EEF2FA',
    tileSoft: { from: '#D8E4FF', fromOpacity: 0.55, to: '#EEF6FF', toOpacity: 0.35 },
    nodes: { top: '#1C39F5', br: '#1575C4', bl: '#1C39F5' },
    frameOpacity: 0.55,
    linkOpacity: 0.5,
    meshOpacity: 0.26,
    hubRingOpacity: 0.62,
  },
  dark: {
    ink: '#FFFFFF',
    markGradient: { from: '#6B87FF', to: '#3DD4F0' },
    wordGradient: { from: '#A8BEFF', to: '#56E9F5' },
    tileFill: '#141B2E',
    nodes: { top: '#8AA8FF', br: '#48E0F5', bl: '#8AA8FF' },
    frameOpacity: 0.82,
    linkOpacity: 0.78,
    meshOpacity: 0.42,
    hubRingOpacity: 0.88,
  },
} as const satisfies Record<'light' | 'dark', LogoThemePalette>;
